module.exports = __webpack_public_path__ + "img/i_main_chat.b156e3ed.svg";